import { dispatchCustomEvent } from "@/helpers/triggerAnalyticsEvent";
import shoppingBag from "@/icons/shoppingbag.svg";

const ShoppingBag = () => {
  return (
    <div className="pb-4 pr-2">
      <img src={amazingRightSectionDetails?.shoppingIcon} alt=""  />
    </div>
  );
};

const CallToAction = () => {
  const handleClick = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });

    const searchId =
      window.innerWidth <= 768 ? "mobile-search-bar" : "search-bar";

    document.getElementById(searchId)?.focus();

    dispatchCustomEvent({
      dataObject: "body-callToAction",
      dataType: "button",
      dataReason: "Joyhunt_start_your_search",
    });
  };

  return (
    <div className="h-[288px] sm:h-[256px] xl:h-[176px] bg-syfYellow rounded-[16px] flex flex-col xl:flex-row text-charcoal gap-[24px] xl:gap-32 items-center relative">
      <div className="flex gap-4 mt-[40px] xl:mt-0 xl:ml-[96px] z-10">
        <div className="ml-4">
          <div className="flex items-center ">
            <ShoppingBag />
            <h3 className="text-[32px] sm:text-[48px] font-bold uppercase leading-[24px]">
            {amazingRightSectionDetails?.sectionHeading}
            </h3>
          </div>
          <div className="ml-[48px]">
            <span className="text-[20px] w-[271px] sm:w-[400px] lg:w-[472px] sm:text-[24px] leading-[32px]  text-wrap ">
            {amazingRightSectionDetails?.sectionSubheading}
            </span>
          </div>
        </div>
      </div>
      <button
        className="syfclickevent w-[320px] sm:w-[343px] h-[80px] bg-white font-bold text-[20px] sm:text-[24px] leading-[48px] uppercase rounded-[8px] flex items-center justify-center gap-3 z-10"
        onClick={handleClick}
        data-object="body-callToAction"
        data-type="button"
        data-reason="Joyhunt_start_your_search"
      >
        <img src={amazingRightSectionDetails?.searchIcon} alt="" />
        <span className="text-charcoal"> {amazingRightSectionDetails?.searchCTAText} </span>
      </button>
      <img src={amazingRightSectionDetails?.sectionBgImage} alt="" className="z-0 absolute right-1 xl:right-24  top-0 xl:-top-16 transition-all ease-in duration-200 peer-hover:scale-[1.08]" />
    </div>
  );
};

export default CallToAction;
